/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreatePricePolicyPage = lazyLoad(
  () => import('./index'),
  module => module.CreatePricePolicyPage
);
